import { ROUTES } from "@/router/routes";

// All routes that require authentication unless explicitly marked as public
const PUBLIC_ROUTES = [
  "/", // Landing page (public)
  ROUTES.AUTH, // Authentication pages
  "/u/", // User profile pages (dynamic)
  "/memos/", // Individual memo detail pages (dynamic) - legacy redirect
  "/journals/", // Individual journal detail pages (dynamic)
] as const;

export function isPublicRoute(path: string): boolean {
  return PUBLIC_ROUTES.some((route) => path.startsWith(route));
}

export function redirectOnAuthFailure(): void {
  const currentPath = window.location.pathname;

  // Don't redirect if it's a public route
  if (isPublicRoute(currentPath)) {
    return;
  }

  // Redirect to auth page for all non-public routes when not authenticated
  window.location.replace(ROUTES.AUTH);
}
